export function buildApiUrl(rootPathAndParameters) {
  let apiUrl = process.env.VUE_APP_API_URL
  if(apiUrl.toLowerCase().startsWith("https://"))
    apiUrl = apiUrl.substring(8)

  return apiUrl === process.env.VUE_APP_BASE_URL ? rootPathAndParameters : `https://${apiUrl}${rootPathAndParameters}`
}

